// extracted by mini-css-extract-plugin
export default {"boardsContainer":"BoardsList_boardsContainer__RSCw-"};